import type { ContextGuards } from './types.js';

export function hasFlagEnabled(flag: string) {
  return (ctx: ContextGuards) => {
    if (!ctx.flagsService) {
      console.warn('Flags service not available');
      return false;
    }
    return ctx.flagsService.hasFeature(flag);
  };
}
